import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.sass']
})
export class NotificationComponent implements OnInit {

    @Input()
    type: 'info' | 'error' | 'warning';

    @Input()
    title: string;

    @Input()
    message: string;

    get headerClass(): string {
        switch (this.type) {
            case "error":
                return "text";
        }
    }

    constructor(public modal: NgbActiveModal) {
    }

    ngOnInit() {
    }

}
